/* eslint-disable no-param-reassign */
import location from '../../prop/location'
import routeObj from '../router-views'
import { first, cloneDeep, isNil } from 'lodash'
const assembleConstraints = require('../assembleConstraints')
// eslint-disable-next-line no-unused-vars
let BASE_URL_FRONTEND = ''
let BASE_URL = ''
// eslint-disable-next-line no-unused-vars
let BASE_URL_PENALTY_CHARGE_NOTICE = ''
// eslint-disable-next-line no-unused-vars
let BASE_URL_AWDOC = ''
// eslint-disable-next-line no-unused-vars
let DOMAIN = ''
// eslint-disable-next-line no-unused-vars
let ORGANIZATION = ''
let USE_ASSET = false
const axios = require('axios')
const dimetiorHttpCode = 'dimetiorHttpCode'
const violazioniHttpCode = 'violazioniHttpCode'

switch (location) {
  case 'local':
    BASE_URL = 'https://test.dimetior.com/dimetior'
    BASE_URL_FRONTEND = 'https://dimetior-dev.awtech.it'
    BASE_URL_PENALTY_CHARGE_NOTICE = 'https://violazioni-dev.awtrack.it/ds'
    BASE_URL_AWDOC = 'https://api-dev-orologio.awdoc.com/connector'
    DOMAIN = 'dominio1'
    ORGANIZATION = 'chiara.com'
    USE_ASSET = true
    // BASE_URL_PENALTY_CHARGE_NOTICE = 'http://localhost:9095'
    break

  case 'test':
    BASE_URL = 'https://test.dimetior.com/dimetior'
    BASE_URL_FRONTEND = 'https://dimetior-dev.awtech.it'
    BASE_URL_PENALTY_CHARGE_NOTICE = 'https://violazioni-dev.awtrack.it/ds'
    BASE_URL_AWDOC = 'https://api-dev-orologio.awdoc.com/connector'
    DOMAIN = 'dominio1'
    ORGANIZATION = 'chiara.com'
    USE_ASSET = true
    break

  case 'prod':
    BASE_URL = 'https://www.dimetior.com/dimetior'
    BASE_URL_FRONTEND = 'https://orologio.awtrack.it'
    BASE_URL_PENALTY_CHARGE_NOTICE = 'https://violazioni-orologio.awtrack.it/ds'
    BASE_URL_AWDOC = 'https://api-orologio.awdoc.com/connector'
    DOMAIN = 'AWTrack'
    ORGANIZATION = 'Eurema'
    break

  default:
    BASE_URL = ''
    break
}

function checkToken (Vue) {
  const session = Vue.getLocalStorage('session')
  const token = session && session.token
  axios.defaults.headers.common.Authorization = `BEARER ${token}`
  axios.defaults.baseURL = BASE_URL
}

function getErrorMessage (it, errorObj, serverHttpCode) {
  it.$root.$emit('activeLoader', false)
  const error = errorObj && errorObj.response
  let errorMessage = ''
  if (error && error.data && error.data.constraint) {
    const isAssembleConstraint = assembleConstraints.default[error.data.constraint]
    const constraints = isAssembleConstraint || it.$t(`constraints.${error.data.constraint}`, 1)
    let completeMessage = ''
    if (Array.isArray(constraints)) {
      constraints.forEach((constraint, index) => {
        const message = it.$tc(constraint.message, constraint.option)
        completeMessage += index !== 0 ? ` ${message.toLowerCase()}` : message
      })
    } else {
      completeMessage = constraints
    }
    errorMessage = completeMessage
  } else if (!isNil(error) && !isNil(error.data) && !isNil(error.data.code)) {
    errorMessage = serverHttpCode ? it.$t(`${serverHttpCode}.${error.status}.${error.data.code}`, 1) : it.$t(`dimetiorHttpCode.${error.status}.${error.data.code}`, 1)
  } else if (error && error.status) {
    if (it && it.$t) {
      const httpCode = !isNil(serverHttpCode) ? serverHttpCode : 'dimetiorHttpCode'
      if (error.status === 404) {
        errorMessage = it.$t(`${httpCode}.${error.status}.0`, 1)
      } else {
        errorMessage = it.$t(`${httpCode}.${error.status}`, 1)
      }
      if (error.status === 403 || error.status === 440) {
        it.$root.$emit('mustBeDisconnected', errorMessage)
      }
    }
  } else if (error) errorMessage = error
  return errorMessage
}

function findRoute (item, routes) {
  if (!routes || routes.length === 0) return null
  let path = first(item.path.split('?'))
  let isEdit = false

  if (item && item.params && Object.keys(item.params).length) {
    Object.keys(item.params).forEach(field => {
      path = first(item.path.split(item.params[field]))
    })
  }

  if (item && item.params && Object.keys(item.params).length) {
    Object.keys(item.params).forEach(field => {
      if (field === 'id') isEdit = true
      path = first(item.path.split(item.params[field]))
    })
  }

  if (item.name !== 'Login') {
    while (path.slice(-1) === '/') {
      path = path.slice(0, -1)
    }
  }
  path = isEdit ? `${path}/:id` : path

  let foundedItem = null
  routes.forEach(route => {
    if (route.path === path) foundedItem = route
    else if (route.child && route.child.length !== 0 && !foundedItem) {
      foundedItem = findRoute(item, route.child)
    }
  })
  return foundedItem
}

function findRouteByPath (path, routes) {
  if (!routes || routes.length === 0) return null

  let foundedItem = null
  routes.forEach(route => {
    if (route.path === path) foundedItem = route
    else if (route.child && route.child.length !== 0 && !foundedItem) {
      foundedItem = findRouteByPath(path, route.child)
    }
  })
  return foundedItem
}

function findLastParent (path, parent) {
  let foundedItem = null

  parent.child.forEach(route => {
    if (route.path === path) foundedItem = parent
    else if (route.child && route.child.length !== 0 && !foundedItem) {
      foundedItem = findLastParent(path, route)
    }
  })
  return foundedItem
}

function getAbsoluteLastParent (path) {
  let result = null
  routeObj.allItems.forEach(item => {
    if (item && item.child && item.child.length !== 0) {
      const foundedParent = findLastParent(cloneDeep(path), item)
      if (foundedParent && !result) result = foundedParent
    } else {
      if (item.path === path) result = item
    }
  })

  if (result && !isNil(path) && path.includes('/:id')) {
    return getAbsoluteLastParent(cloneDeep(result.path))
  }

  return result
}

function getLogObj (it, method, path) {
  const foundedItem = findRoute(it.$route ? it.$route : it, routeObj.allItems)
  const routeName = foundedItem && foundedItem.title ? foundedItem.title : null

  return {
    function: path,
    mode: method,
    data: {
      route: routeName,
      routePath: foundedItem.path
    }
  }
}

function checkPermissions (item, routes) {
  const path = item.path
  if (path === '/redirect' || path === '/login' || path === '/' || path === '/logout' || path === '/home' || path === '/awdoc') return true
  const foundedRoute = findRoute(item, routes)

  if (foundedRoute) {
    // config[crud], create - read - update - delete
    return foundedRoute.config && foundedRoute.config.r ? foundedRoute : null
  }
  return false
}

const MyServerInteraction = {
  install (Vue) {
    Vue.myGet = (it, path, obj) => {
      checkToken(Vue)

      return axios.get(path).then((response) => {
        if (response && response.data && response.data[obj]) {
          return response.data[obj]
        } else if (response && response.data) {
          return response.data
        }
        return response
      }).catch(error => {
        return getErrorMessage(it, error, dimetiorHttpCode)
      })
    }
    Vue.putOrPost = (it, put, path, obj, hasLog) => {
      checkToken(Vue)
      const logObj = getLogObj(it, put ? 'put' : 'post', path)

      return put ? axios.put(path, obj).then(r => {
        if (hasLog) Vue.myLogPost(logObj)
        return r
      }).catch(r => {
        if (hasLog) Vue.myLogPost(logObj)
        throw r
      }) : axios.post(path, obj).then(r => {
        if (hasLog) Vue.myLogPost(logObj)
        return r
      }).catch(r => {
        throw r
      })
    }
    Vue.myDelete = (it, path) => {
      checkToken(Vue)
      const logObj = getLogObj(it, 'delete', path)

      return axios.delete(path).then(r => {
        Vue.myLogPost(logObj)
        return r
      }).catch(r => {
        throw r
      })
    }
    Vue.getBaseUrl = () => {
      checkToken(Vue)
      return BASE_URL
    }
    Vue.getBaseUrlFrontend = () => {
      return BASE_URL_FRONTEND
    }
    Vue.getBaseUrlPenaltyChargeNotice = () => {
      checkToken(Vue)
      return BASE_URL_PENALTY_CHARGE_NOTICE
    }
    Vue.getBaseUrlAWDoc = () => {
      return BASE_URL_AWDOC
    }
    Vue.getDomain = () => {
      return DOMAIN
    }
    Vue.getOrganization = () => {
      return ORGANIZATION
    }
    Vue.getViolazioniHttpCode = () => {
      return violazioniHttpCode
    }
    Vue.getDimetiorHttpCode = () => {
      return dimetiorHttpCode
    }
    Vue.getUseAssets = () => {
      return USE_ASSET
    }
    Vue.myAll = (array) => {
      return axios.all(array).then(r => r).catch(r => { throw r })
    }
    Vue.manageErrors = (it, error, serverHttpCode) => {
      it.$root.$emit('activeLoader', false)
      console.log(error)
      const message = getErrorMessage(it, error, serverHttpCode)
      if (message) Vue.error(it, message)
      else Vue.error(it, it.$t('dimetiorHttpCode.422.3', 1))
      return message
    }
    Vue.myLogin = (it, username, password) => {
      checkToken(Vue)
      const logObj = getLogObj(it, 'get', '/login')

      return axios.get('/login', {
        auth: { username, password }
      }).then((response) => {
        const session = response.data
        const config = session && session.user && session.user.config

        if (config) {
          if (config.disabled === 'true') {
            Vue.error(it, it.$tc('errors.userIsDisabled', 1))
            return false
          }
        }

        Vue.deleteLocalStorage('routes')
        Vue.setLocalStorage('routes', btoa(config.routes))
        delete session.user.config.routes
        Vue.setLocalStorage('session', session)
        Vue.deleteLocalStorage('isExpelled')
        checkToken(Vue)
        Vue.myLogPost(logObj)
        return response
      }).catch((error) => {
        throw error && error.response ? getErrorMessage(it, error, dimetiorHttpCode) : error
      })
    }
    Vue.myLogPost = (logObj) => {
      checkToken(Vue)
      const path = '/application_logs'
      logObj.function = JSON.stringify(logObj.function)
      if (logObj) return axios.post(path, logObj).then(() => true).catch(() => false)
      return null
    }
    Vue.myFindSection = (path) => getAbsoluteLastParent(path)
    Vue.getConfigByRouteItem = (item) => {
      let routes = Vue.getLocalStorage('routes')
      routes = routes ? JSON.parse(atob(routes)) : null
      return checkPermissions(item, routes)
    }
    Vue.downloadURI = (url, name) => {
      const link = document.createElement('a')
      link.download = name
      link.href = `${BASE_URL.replace('/dimetior', '')}/${url}`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
    Vue.findRouteObjByPath = (path) => {
      const obj = findRouteByPath(path, routeObj.allItems)

      return {
        name: obj.component.name,
        path: obj.path,
        title: obj.title
      }
    }
    Vue.getLogObj = (it, method, path) => {
      return getLogObj(it, method, path)
    }
  }
}

export default MyServerInteraction
